<template>
  <section id="event-register">
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      v-if="isLoading"
    ></b-loading>
    <ValidationObserver ref="form" @submit.prevent="handleSubmit" v-else>
      <form>
        <div class="is-flex is-justify-content-start" style="gap: 16px">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Event"
            style="flex: 1"
          >
            <b-field
              label="Event"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-select
                v-model="formProps.event"
                placeholder="Select an event"
                expanded
              >
                <optgroup
                  v-for="group in eventGroups"
                  :key="group.eventGroup"
                  :label="group.eventGroup"
                >
                  <option
                    v-for="event in group.events"
                    :key="event.eventId"
                    :value="event"
                  >
                    {{ event.eventName }}
                  </option>
                </optgroup>
              </b-select>
            </b-field>
          </ValidationProvider>

          <b-field label="Quantity">
            <b-numberinput
              :controls="false"
              v-model="quantity"
              disabled
            ></b-numberinput>
          </b-field>
        </div>
        <div class="is-flex is-justify-content-start mt-3" style="gap: 16px">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="School name"
            style="flex: 1"
          >
            <b-field
              label="School name"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-input
                v-model="formProps.schoolName"
                placeholder="School name"
              ></b-input>
            </b-field>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Registrant type"
          >
            <b-field
              label="Registrant type"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-select
                v-model="formProps.registrantType"
                placeholder="Registrant type"
                expanded
              >
                <option value="chess_coordinator">Chess Coordinator</option>
                <option value="parent">Parent</option>
              </b-select>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="is-flex is-justify-content-start mt-3" style="gap: 16px">
          <ValidationProvider
            rules="required|email"
            v-slot="{ errors }"
            name="Email address"
            style="flex: 1"
          >
            <b-field
              label="Email address"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-input
                v-model="formProps.email"
                placeholder="Email address"
              ></b-input>
            </b-field>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" name="Mobile phone">
            <b-field
              label="Mobile phone"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-input
                v-model="formProps.phoneNumber"
                placeholder="Phone number"
              ></b-input>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="is-flex is-justify-content-start mt-3" style="gap: 16px">
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="Division"
            style="flex: 1"
          >
            <b-field
              label="Division"
              :type="errors.length ? 'is-danger' : ''"
              :message="errors.length ? errors[0] : ''"
            >
              <b-checkbox v-model="formProps.division" native-value="primary">
                Primary
              </b-checkbox>
              <b-checkbox v-model="formProps.division" native-value="secondary">
                Secondary
              </b-checkbox>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="mt-3" v-if="formProps.division.includes('primary')">
          <p class="is-size-6"><strong>Primary</strong></p>
          <b-table
            :data="formProps.primary.length ? formProps.primary : []"
            :hoverable="true"
            :focusable="true"
            style="width: 100%"
          >
            <b-table-column
              field="firstName"
              label=""
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <strong style="padding-top: 2px; display: inline-block">
                {{ person.index + 1 }}
              </strong>
            </b-table-column>
            <b-table-column
              field="firstName"
              label="First name"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="First name"
                :vid="`primary-firstName-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.firstName"
                    placeholder="First name"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="surName"
              label="Surname"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Surname"
                :vid="`primary-surName-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.surName"
                    placeholder="Surname"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="birthday"
              label="Birthday"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Birthday"
                :vid="`primary-birthday-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-datepicker
                    size="is-small"
                    v-model="person.birthday"
                    placeholder="Birthday"
                    icon="calendar"
                  >
                    <template #left>
                      <b-button
                        label="Now"
                        type="is-primary"
                        icon-left="clock"
                      />
                    </template>

                    <template #right>
                      <b-button
                        label="Clear"
                        type="is-danger"
                        icon-left="close"
                        outlined
                        @click="person.birthday = null"
                      />
                    </template>
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="emergencyContactNumber"
              label="Emergency contact number"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Emergency contact number"
                :vid="`primary-emergencyContactNumber-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.emergencyContactNumber"
                    placeholder="Emergency contact number"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
          </b-table>
          <b-button
            label="Add row"
            type="is-secondary"
            size="is-small"
            class="mt-4"
            @click="addPrimaryRow"
          >
          </b-button>
        </div>
        <div class="mt-3" v-if="formProps.division.includes('secondary')">
          <p class="is-size-6"><strong>Secondary</strong></p>
          <b-table
            :data="formProps.secondary.length ? formProps.secondary : []"
            :hoverable="true"
            :focusable="true"
            style="width: 100%"
          >
            <b-table-column
              field="firstName"
              label=""
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <strong style="padding-top: 2px; display: inline-block">
                {{ person.index + 1 }}
              </strong>
            </b-table-column>
            <b-table-column
              field="firstName"
              label="First name"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="First name"
                :vid="`secondary-firstName-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.firstName"
                    placeholder="First name"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="surName"
              label="Surname"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Surname"
                :vid="`secondary-surName-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.surName"
                    placeholder="Surname"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="birthday"
              label="Birthday"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Birthday"
                :vid="`secondary-birthday-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-datepicker
                    size="is-small"
                    v-model="person.birthday"
                    placeholder="Birthday"
                    icon="calendar"
                  >
                    <template #left>
                      <b-button
                        label="Now"
                        type="is-primary"
                        icon-left="clock"
                      />
                    </template>

                    <template #right>
                      <b-button
                        label="Clear"
                        type="is-danger"
                        icon-left="close"
                        outlined
                        @click="person.birthday = null"
                      />
                    </template>
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </b-table-column>
            <b-table-column
              field="emergencyContactNumber"
              label="Emergency contact number"
              cell-class="has-text-left"
              v-slot="{ row: person }"
            >
              <ValidationProvider
                v-slot="{ errors }"
                name="Emergency contact number"
                :vid="`secondary-emergencyContactNumber-${person.index}`"
              >
                <b-field
                  :type="errors.length ? 'is-danger' : ''"
                  :message="errors.length ? errors[0] : ''"
                >
                  <b-input
                    size="is-small"
                    v-model="person.emergencyContactNumber"
                    placeholder="Emergency contact number"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </b-table-column>
          </b-table>
          <b-button
            label="Add row"
            type="is-secondary"
            size="is-small"
            class="mt-4"
            @click="addSecondaryRow"
          >
          </b-button>
        </div>

        <b-button
          label="Checkout"
          type="is-primary"
          class="mt-5"
          native-type="submit"
        >
        </b-button>
      </form>
    </ValidationObserver>
  </section>
</template>

<script>
import _ from "lodash";
import { firestore, functions } from "@/services/firebase";

const handleGeneratePaymentLink = functions.httpsCallable(
  "stripe-handleGeneratePaymentLink"
);

export default {
  components: {},

  name: "EventRegister",

  data() {
    return {
      isLoading: true,
      tournamentEvents: undefined,
      formProps: {
        event: undefined,
        schoolName: undefined,
        registrantType: undefined,
        email: undefined,
        phoneNumber: undefined,
        division: [],
        primary: [
          {
            index: 0,
            firstName: undefined,
            surName: undefined,
            birthday: undefined,
            emergencyContactNumber: undefined,
          },
        ],
        secondary: [
          {
            index: 0,
            firstName: undefined,
            surName: undefined,
            birthday: undefined,
            emergencyContactNumber: undefined,
          },
        ],
      },
    };
  },

  firestore: {
    tournamentEvents: firestore.collection("tournamentEvents"),
  },

  watch: {
    tournamentEvents() {
      if (!this.tournamentEvents) {
        return;
      }

      this.isLoading = false;
    },
  },

  computed: {
    eventGroups() {
      if (!this.tournamentEvents) {
        return [];
      }

      return _.chain(this.tournamentEvents ?? [])
        .groupBy("eventGroup")
        .map((value, key) => {
          return { eventGroup: key, events: value };
        })
        .value()
        .sort((g1, g2) => g1.eventGroup.localeCompare(g2.eventGroup));
    },

    quantity() {
      return [
        ...(this.formProps.primary ?? []).filter((p) => !!p.firstName),
        ...(this.formProps.secondary ?? []).filter((p) => !!p.firstName),
      ].length;
    },
  },

  methods: {
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      const params = {
        line_items: [
          {
            price: this.formProps.event.priceId,
            quantity: this.quantity,
          },
        ],
        metadata: {
          ...this.formProps,
          event: JSON.stringify(this.formProps.event),
          division: JSON.stringify(this.formProps.division),
          primary: JSON.stringify(this.formProps.primary),
          secondary: JSON.stringify(this.formProps.secondary),
        },
      };

      const response = await handleGeneratePaymentLink(params);
      const { url } = response.data;
      window.location.href = url;
    },

    addPrimaryRow() {
      this.formProps.primary.push({
        index: this.formProps.primary.length,
        firstName: undefined,
        surName: undefined,
        birthday: undefined,
        emergencyContactNumber: undefined,
      });
      window.scrollTo(
        0,
        document.body.scrollHeight || document.documentElement.scrollHeight
      );
    },

    addSecondaryRow() {
      this.formProps.secondary.push({
        index: this.formProps.secondary.length,
        firstName: undefined,
        surName: undefined,
        birthday: undefined,
        emergencyContactNumber: undefined,
      });
      window.scrollTo(
        0,
        document.body.scrollHeight || document.documentElement.scrollHeight
      );
    },
  },
};
</script>

<style scoped>
#event-register {
  background-color: white;
  min-height: 280px;
  padding: 1rem;
  margin-top: 5rem;
  margin-bottom: 15rem;
  position: relative;
  text-align: left;
  border-radius: 17px;
}

@media (min-width: 991px) {
  #event-register {
    width: 860px;
  }
}
</style>
